module.exports = __webpack_public_path__ + "img/twitter-icon-blue.3e44704.svg";